import { useEffect, useRef } from "react";

// Faint background mark (a logo, large and nearly transparent) that settles into place the
// first time it scrolls into view. The caller's className sets the resting look (position,
// size, tilt, opacity, hover); .ft-watermark in animations.css adds only the arrival, on an
// inner wrapper so it never fights the caller's hover transitions. `sway` keeps it drifting
// gently afterwards, and `delay` (ms) staggers marks in a grid or waits for an intro.
export default function Watermark({ className = "", sway = false, delay = 0, children }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      el.classList.add("is-in");
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        el.classList.add("is-in");
        observer.disconnect();
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <span
      ref={ref}
      className={`ft-watermark${sway ? " ft-watermark--sway" : ""} ${className}`.trim()}
      style={delay ? { "--ft-watermark-delay": `${delay}ms` } : undefined}
      aria-hidden="true"
    >
      <span className="ft-watermark__inner">{children}</span>
    </span>
  );
}
